<script lang="ts">
  import {
    Checkbox,
    Column,
    Dropdown,
    FormGroup,
    Grid,
    Row,
    TextInput,
  } from "carbon-components-svelte";
  import { Helper } from "./../../ts/Helper";
  import type { IFontOptions, IText } from "./../../ts/Interfaces";
  import { optionsData } from "./../../ts/Stores";
  import Border from "./Border.svelte";
  import FontStyle from "./FontStyle.svelte";
  import Alignment from "./Alignment.svelte";
  import SpacingGroup from "./SpacingGroup.svelte";

  export let line: IText;

  let options: IFontOptions;
  optionsData.subscribe((optionsData) => {
    options = optionsData.fontOptions;
  });

  let fonts = Helper.ToIdTextPair(options.names);
  let sizes = Helper.ToIdTextPair(options.sizes);

  // Commented code is for setting focus on last opened accordion item's text input
  // var textinput: HTMLInputElement;
  // export const setfocus = () => {
  //   console.log(textinput);
  //   textinput?.focus();
  // };
  // bind:ref={textinput}
</script>

<div class="line stack">
  <TextInput
    labelText="Text"
    placeholder="Enter text for this line"
    bind:value={line.content}
  />
  {#if !line.hideIsCurved}
    <FormGroup legendText="Text Curvature" noMargin>
      <Checkbox labelText="Curve Text" bind:checked={line.isCurved} />
      <Checkbox
        labelText="Curve Counter Clockwise"
        disabled={!line.isCurved}
        bind:checked={line.counterClockwiseDirection}
      />
    </FormGroup>
  {/if}
  {#if !line.hideFont}
    <div class="flex-wrap">
      {#if !line.font.hideName}
        <Dropdown
          titleText="Font"
          items={fonts}
          bind:selectedId={line.font.name}
        />
      {/if}
      {#if !line.font.hideSize}
        <Dropdown
          titleText="Size"
          items={sizes}
          bind:selectedId={line.font.size}
        />
      {/if}
      {#if !line.font.hideDecoration}
        <FontStyle
          bind:group={line.font.decoration}
          values={options.decoration}
        />
      {/if}
    </div>
    {#if !line.hideAlignment}
      <Alignment bind:alignment={line.horizontalAlignment} />
    {/if}
    {#if !line.hideBorder}
      <Border bind:border={line.border} />
    {/if}
    {#if !line.hideSpacing}
      <SpacingGroup bind:spacing={line.spacing} />
    {/if}
  {/if}
</div>
